import { useState, useMemo } from "react";
import { NumberField, Stat, ToolShell } from "./parts";
import { inr } from "@/lib/format";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const TYPES = {
  affordable: { label: "Under-construction · Affordable", rate: 1 },
  regular: { label: "Under-construction · Premium", rate: 5 },
  ready: { label: "Ready-to-move (with CC)", rate: 0 },
};

export function GstCalculator() {
  const [value, setValue] = useState(6000000);
  const [type, setType] = useState("regular");

  const { rate, gst, total } = useMemo(() => {
    const rate = TYPES[type].rate;
    const gst = (value * rate) / 100;
    return { rate, gst, total: value + gst };
  }, [value, type]);

  return (
    <ToolShell title="GST on Property" desc="GST applies only to under-construction homes. Affordable housing attracts 1%, other under-construction 5% (both without input tax credit). Ready-to-move properties with a completion certificate attract no GST.">
      <div className="grid gap-10 lg:grid-cols-2">
        <div className="space-y-8">
          <NumberField label="Property Base Price" value={value} onChange={setValue} min={1000000} max={200000000} step={100000} prefix="₹" testid="gst-value" />
          <div className="space-y-3">
            <label className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Property Type</label>
            <Select value={type} onValueChange={setType}>
              <SelectTrigger className="tool-input rounded-none" data-testid="gst-type"><SelectValue /></SelectTrigger>
              <SelectContent>
                {Object.entries(TYPES).map(([k, v]) => <SelectItem key={k} value={k}>{v.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="space-y-5">
          <Stat label={`GST @ ${rate}%`} value={inr(gst)} highlight testid="gst-result" />
          <Stat label="Total Cost (incl. GST)" value={inr(total)} />
          <p className="border border-border bg-background p-4 font-mono text-xs leading-relaxed text-muted-foreground">
            Affordable housing = up to ₹45L value (carpet area limits apply). Stamp duty & registration are charged separately over and above GST.
          </p>
        </div>
      </div>
    </ToolShell>
  );
}
